import React, { useState, useEffect, useRef } from 'react';
import  { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom'
import Dropzone from 'react-dropzone';
import { api } from '../utils/endpoint.js'

import { connect } from 'react-redux';
import { 
  updateContactInfo, updateContactInfoTemporary, updateClaimType, deleteDocTypeAll, updateClaimId,
  updateLicense, updateRequestDocuments
} from '../reducers/formActions'
import { updateNotify } from '../reducers/formActions'

import ThaivivatLogo from '../components/ThaivivatLogo.js'
import iconModalClose from '../images/modal/ic_close.svg'
import iconModalUpload from '../images/modal/ic_upload.svg'
import imgQuestion from '../images/inform/question.svg'

import iconCloseAlert from '../images/alert/ic_close.svg'
import iconTrash from '../images/additionalDocument/trash.svg'
import iconReset from '../images/additionalDocument/reset.svg'
import iconArrorLeft from '../images/additionalDocument/arrow-left.svg'
import iconVector from '../images/additionalDocument/vector-icon.svg'
import iconError from '../images/additionalDocument/error-icon.svg'

import ProgressWaiting from '../components/progress-wating.js'
import ModalAlertError from '../components/ModalAlertError'

import Swal from 'sweetalert2'
import { compressImage } from '../utils/compress-image'
import AdditionalDocumentInfo from '../components/additionalDocumentInfo'
import AdditionalDocumentError from '../components/additionalDocumentError.js'
import AdditionalDocumentSubmit from '../components/additionalDocumenSubmit.js'


function AdditionalDocument(props) {
  const navigate = useNavigate();
  const { state } = useLocation()

  const [ isShowAlertError, setIsShowAlertError ] = useState(false)
  const [ alertTitle, setAlertTitle ] = useState('')
  const [ alertMessage, setAlertMessage ] = useState('')

  const showAlertError = (title, message) => {
    setAlertTitle(title)
    setAlertMessage(message)
    setIsShowAlertError(true)
  }

  const confirmClickError = () => {
    setIsShowAlertError(false)
    setIsShowLoading(false)
  }

  useEffect(() => {
    const onscroll = () => {
      const scrolledTo = window.scrollY + window.innerHeight;
      if ( (scrolledTo > document.body.scrollHeight - 200) && document.body.clientWidth <= 767  ){
          setIsShowHelpButton('-100px')
      }else{
        setIsShowHelpButton('100px')
      }
    };
    window.addEventListener("scroll", onscroll);
    return () => {
      window.removeEventListener("scroll", onscroll);
    };
  }, []);

  // xxx
  const [ isShowUploadModal, setIsShowUploadModal ] = useState(false)
  const [ isShowHelpModal, setIsShowHelpModal ] = useState(false)
  const [ isShowHelpButton, setIsShowHelpButton ] = useState('100px')
  const [ isShowLoading, setIsShowLoading ] = useState(false)
  const [ isStep, setIsStep ] = useState('') //info, error, submit

  const [ isEditFileList, setIsEditFileList ]= useState(false)
  const [ fileList, setFileList ]= useState([])
  const [ docType, setDocType ]= useState("")
  const [ indexDocType, setIndexDocType ]= useState(null)
  const [ headerDocType, setHeaderDocType ]= useState('')
  const [ errorCode, setErrorCode ]= useState('')
  
  const [ tokenSms, setTokenSms ] = useState(null)
  let { referenceNo } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const token = searchParams.get('token')
    if(token){
      setTokenSms(token)
      callApiRequestDocuments(token)

    }else{
      setIsStep('error')
    }
  },[])


  function onReUploadFile( file, docType, index ){
    uploadToServer(file, docType, index)
  }
  function onUploadFile( files, docType ){
    setIsEditFileList(true)
    for(let i = 0; i < files.length; i++){
      uploadToServer(files[i], docType)
    }
  }

  async function uploadToServer( file, docType, index = null ){
    callApiUpload( file, docType, index )
  }

  async function callApiUpload( file, docType, index = null  ) {
    setIsShowLoading(true)
    const formData = new FormData();
    formData.append("file", file)
    let fileCompress = await compressImage(file)
    if(fileCompress !== null){
      formData.append("thumb", fileCompress)
    }
    const requestOptions = {
      method: 'POST',
      body: formData
    };
    fetch(api.requestDocuments.getRequestDocumentsUpload(referenceNo,`?docType=${docType}&notifyNo=${props.notify_no}&token=${tokenSms}`), requestOptions)
    .then(response => response.json())
    .then(data => onSuccessCallApiUpload(data,file, index), (error) => {
    
      if (error) {
        showAlertError('เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4')
      }
    });
  }

  function onSuccessCallApiUpload( data, file, index = null ){
    console.log('onSuccessCallApiUpload : ' ,data)
    if(data.id){
      setIsShowLoading(false)
      updateFileList(data, docType, index, file)
    }else{
      setIsShowLoading(false)
      onFailCallApiUpload(file, index)
    }
  }

  async function readFile(file) {
    const text = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
    return text;
  }
  async function onFailCallApiUpload( file, index = null ){
    console.log('onFailCallApiUpload :: file : ',file)
    setIsShowLoading(false)
    
    const fileImage = await readFile(file)
    
    const objFile = {
      id:  null,
      fileName : null,
      filePath : null,
      fileSize: file.size,
      date : null,
      fileType: file.type,
      uploadStatus: 'fail',
      fileUpload: file,
      fileImage
    }

    let filePrevState = fileList
    if(index === null){
      filePrevState.push(objFile)
    }else{
      filePrevState[index] = objFile
    }
    setFileList([...filePrevState])
  }

  async function updateFileList(data, docType, index = null, file){
    let filePrevState = fileList

    let objFile = {
      id:  data.id,
      fileName : data.fileName,
      filePath : data.filePath,
      fileSize: data.fileSize,
      date: data.updateAt,
      fileType: data.fileType,
      uploadStatus: 'success'
    }

    if(index === null){
      filePrevState.push(objFile)
    }else{
      filePrevState[index] = objFile
    }
    setFileList([...filePrevState])
  }

  async function saveFiles(){
    console.log('saveFiles : ')
    console.log('fileList : ',fileList)
    console.log('indexDocType : ',indexDocType)

    if(fileList.length === 0){
      setIsShowUploadModal(false)
    }

    for (const item of fileList) {
      console.log('item.id : ',item.id)
      if(item.id === null){
        showConfirmError()
        return;
      }
    } 

    console.log('props.request_documents?.data : ',props.request_documents.data[indexDocType])
    
    const formData = new FormData();
    let runIndex = 0
    
    if(fileList.length){
      for (const file of fileList) {
        formData.append(`files[${runIndex}]`, file.id)
        runIndex++
      }
    }else{
      formData.append(`files`,[])
    }

    const requestOptions = {
      method: 'POST',
      body: formData
    };

    const result =  await fetch(api.requestDocuments.getRequestDocumentsSaveUploads(referenceNo,`?docType=${docType}&notifyNo=${props.notify_no}&token=${tokenSms}`), requestOptions)
    .then(response => response.json())
    .then(data => {
      return data
    }, (error) => {
      if (error) {
        setIsShowAlertErrorTold(true)
        setTimeout(function(){
          setIsShowAlertErrorTold(false)
        }, 2000)
      }
    });


    if(result.statusCode == 400){
      setIsShowAlertErrorTold(true)
      setTimeout(function(){
        setIsShowAlertErrorTold(false)
      }, 2000)
      return
    }

    let temp = props.request_documents.data
    temp[indexDocType].files = [...fileList]
    props.updateRequestDocuments({data: props.request_documents.data})
    setFileList([])
    setIsShowUploadModal(false)
  }

  const [ isShowAlertSuccess, setIsShowAlertSuccessTold ] = useState(false)
  const [ isShowAlertErrorTold, setIsShowAlertErrorTold ] = useState(false)

  async function clearAll(docType){
    setFileList([])
    setIsShowAlertSuccessTold(true)
    setTimeout(function(){
      setIsShowAlertSuccessTold(false)
    }, 2000)
  }

  function deleteImage(docType, index ){
    setIsEditFileList(true)
    if(fileList.length === 0){
      return;
    }
    
    let filePrevState = [...fileList]
    filePrevState.splice(index, 1)
    setFileList([...filePrevState])
    setIsShowAlertSuccessTold(true)
    setTimeout(function(){
      setIsShowAlertSuccessTold(false)
    }, 2000)

  }

  function showConfirmDelete(runFunc, docType, index = null){
    Swal.fire({
      width:343,
      heightAuto:true,
      icon: "info",
      iconColor: "white",
      iconHtml: "<div class='swal-warning-icon'> <img class='question-icon' src='"+imgQuestion+"' '></div>",
      title: '<div data-testid="popup-title-text" class="swal-warning-font" style="font-size: 16px !important;" >ยืนยันการลบรูปภาพ</div>',
      html: `<div data-testid="popup-description-text" class="swal-warning-font" style="font-size: 14px !important;" >คุณต้องการยืนยันการลบรูปภาพหรือไม่?</div>`,
      reverseButtons: true,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      inputAutoFocus: false,
      confirmButtonText: '<span data-testid="confirm-button" >ยืนยัน</span>',
      cancelButtonText: '<span data-testid="cancel-button" style="color: black" >ยกเลิก</span>',
      customClass: {
        confirmButton: 'swal-warning-confirm-delete',
        cancelButton: 'swal-warning-cancel-delete',
        icon: 'swal-warning-cancel-icon',
        closeButton: 'no-focus',
      }

    }).then((result) => {
      if (result.isConfirmed) {
        if(index !== null){
          runFunc(docType, index)
        }else{
          runFunc(docType)
        }
      }
    })
  }

  function showConfirmError(){
    Swal.fire({
      width:343,
      heightAuto:true,
      icon: "info",
      iconColor: "white",
      iconHtml: "<div class='swal-warning-icon'> <img class='question-icon' src='"+imgQuestion+"' '></div>",
      title: '<div data-testid="popup-title-text" class="swal-warning-font" style="font-size: 16px !important;" >กรุณาตรวจสอบรายการอัพโหลด</div>',
      html: `<div data-testid="popup-description-text" class="swal-warning-font" style="font-size: 14px !important;" >เนื่องจากรายการที่อัพโหลดไม่สำเร็จ</div>`,
      showCloseButton: true,
      focusConfirm: false,
      inputAutoFocus: false,
      confirmButtonText: '<span data-testid="confirm-button" >ปิด</span>',
      customClass: {
        confirmButton: 'swal-warning-error',
        icon: 'swal-warning-cancel-icon',
        closeButton: 'no-focus',
      }

    }).then((result) => {
    })
  }

  function showConfirmSubmitError(){
    Swal.fire({
      width:343,
      heightAuto:true,
      icon: "info",
      iconColor: "white",
      iconHtml: "<div class='swal-warning-icon'> <img class='question-icon' src='"+imgQuestion+"' '></div>",
      title: '<div data-testid="popup-title-text" class="swal-warning-font" style="font-size: 16px !important;" >กรุณาระบุเอกสารเพิ่มเติมให้ครบ</div>',
      html: `<div data-testid="popup-description-text" class="swal-warning-font" style="font-size: 14px !important;" >เนื่องจากเอกสารที่ขอเพิ่มเติมยังไม่ได้ระบุ</div>`,
      showCloseButton: true,
      focusConfirm: false,
      inputAutoFocus: false,
      confirmButtonText: '<span data-testid="confirm-button" >ปิด</span>',
      customClass: {
        confirmButton: 'swal-warning-error',
        icon: 'swal-warning-cancel-icon',
        closeButton: 'no-focus',
      }

    }).then((result) => {
    })
  }

  function showConfirmBack(){
    if(isEditFileList){
      Swal.fire({
        width:343,
        heightAuto:true,
        icon: "info",
        iconColor: "white",
        iconHtml: "<div class='swal-warning-icon'> <img class='question-icon' src='"+imgQuestion+"' '></div>",
        title: '<div data-testid="popup-title-text" class="swal-warning-font" style="font-size: 16px !important;" >คุณต้องออกจากหน้านี้</div>',
        html: `<div data-testid="popup-description-text" class="swal-warning-font" style="font-size: 14px !important;" >มีการระบุข้อมูลคุณต้องการที่จะบันทึกหรือไม่</div>`,
        reverseButtons: true,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        inputAutoFocus: false,
        allowOutsideClick: false,
        confirmButtonText: '<span data-testid="confirm-button" >บันทึก</span>',
        cancelButtonText: '<span data-testid="cancel-button" style="color: black" >ไม่</span>',
        customClass: {
          confirmButton: 'swal-warning-confirm-delete',
          cancelButton: 'swal-warning-cancel-delete',
          icon: 'swal-warning-cancel-icon',
          closeButton: 'no-focus',
        }
  
      }).then((result) => {
        console.log('result : ',result)
        if (result.isConfirmed) {
          saveFiles()
        }else if(result.dismiss === 'cancel'){
          setFileList([])
          setIsShowUploadModal(false)
        }
      })
    }else{
      setFileList([])
      setIsShowUploadModal(false)
    }
  }

  async function callApiRequestDocuments(tokenSms) {
    console.log('callApiRequestDocuments')
    setIsShowLoading(true)

    const requestOptions = {
      method: 'GET',
    };
    fetch(api.requestDocuments.getRequestDocuments(`${referenceNo}?token=${tokenSms}`), requestOptions)
    .then( async (response) => {
      if(response.ok){
        return response.json();         
      }

      throw ({status:response.status, body: await response.json()});
    })
    .then(data => setDataRequestDocuments(data), (error) => {
      console.log('error : ',error)
      if(error?.body?.errors?.length > 0){
        setErrorCode(error.body.errors[0].code)
      }
      setIsStep('error')
      setIsShowLoading(false)
      return
    }).catch((error) => {
    });

  }
  function setDataRequestDocuments(data){
    console.log('setDataRequestDocuments : ',data)
    // data = {
    //     "tranId": "33075927910",
    //     "notifyNo": "1650101050",
    //     "status": "WAITING",
    //     "suffererType": "0",
    //     "carLicense": "3กก1234กท",
    //     "carLicenseAlp": "3กก",
    //     "carLicenseNo": "1234",
    //     "licenseProvince": "กท",
    //     "registPlate": "N",
    //     "contactType": 1,
    //     "contactTitleCode": "042",
    //     "contactName": "มาณี ใจงาม",
    //     "isAssignee": false,
    //     "isLegalEntity": false,
    //     "claimType": "1",
    //     "requestDocuments": [
    //         {
    //             "picTypeId": 202,
    //             "picTypeDesc": "ใบเสนอราคา",
    //             "subFolderName": "NON_QUOTATION",
    //             "docType": "2",
    //             "files": [
    //                 {
    //                     "id": 123,
    //                     "fileKey": "1650101050/20240911092353/f71730c9-0a7b-4056-b39a-9ce1da1b5911/1/f5f920ad-d8a5-41bc-9b3b-c4f3a0967317.jpg",
    //                     "thumbKey": "1650101050/20240911092353/f71730c9-0a7b-4056-b39a-9ce1da1b5911/1/f5f920ad-d8a5-41bc-9b3b-c4f3a0967317-thumb.jpg",
    //                     "fileName": "Screenshot 2566-06-22 at 16.04.19.png",
    //                     "filePath": "https://s3-non-emcs.s3.ap-southeast-1.amazonaws.com/1650101050/20240911092353/f71730c9-0a7b-4056-b39a-9ce1da1b5911/1/f5f920ad-d8a5-41bc-9b3b-c4f3a0967317.png",
    //                     "fileThumb": "https://s3-non-emcs.s3.ap-southeast-1.amazonaws.com/1650101050/20240911092353/f71730c9-0a7b-4056-b39a-9ce1da1b5911/1/f5f920ad-d8a5-41bc-9b3b-c4f3a0967317-thumb.png",
    //                     "fileSize": 247496,
    //                     "fileType": "image/png"
    //                 }
    //             ]
    //         },
    //         {
    //             "picTypeId": 203,
    //             "picTypeDesc": "ต้นฉบับใบเสร็จรับเงิน",
    //             "subFolderName": "NON_QUO_REC_TOWCAR_TP",
    //             "docType": "8",
    //             "files": []
    //         }
    //     ]
    // }
    for (const item of data.requestDocuments) {
      if(item.docType === 0){
        setIsStep('error')
        setIsShowLoading(false)
        return
      }
    }

    if(data?.status != 'WAITING'){
      setIsStep('error')
      setIsShowLoading(false)
      return
    }

    props.updateContactInfo(
      {
        name : data.contactName,
        contact_type: data.contactType,
        ref_no: referenceNo,
        carLicense_display: `${data.carLicenseAlp}${data.carLicenseNo} ${data.licenseProvince}`,
      }
    )
    props.updateNotify(data.notifyNo)
    props.updateClaimType({
      type : data.claimType
    })
    props.updateLicense({
      sufferer_type : data.suffererType
    })
    props.updateRequestDocuments({data:data.requestDocuments})
    setIsStep('info')
    setTimeout(function(){
      setIsShowLoading(false)
    }, 1000);
  }

  function openUpload(item, index){
    setIsEditFileList(false)
    setIsShowUploadModal(true)
    setDocType(item.docType)
    setIndexDocType(index)
    setHeaderDocType(item.picTypeDesc)
    let filePrevState = fileList

    console.log('props.request_documents?.data : ',props.request_documents?.data)
    console.log('item : ',item)
    console.log('index : ',index)
    for (const data of item.files) {
      let objFile = {
        id:  data.id,
        fileName : data.fileName,
        filePath : data.filePath,
        fileSize: data.fileSize,
        date: null,
        fileType: data.fileType,
        uploadStatus: 'success'
      }

      filePrevState.push(objFile)
    }

    setFileList([...filePrevState])

  }

  async function submitRequestDocuments(){
    window.scrollTo(0, 0);
    
    for (const data of props.request_documents.data) {
      if(data.files.length <= 0){
        showConfirmSubmitError()
        return
      }
    }
    console.log('submitRequestDocuments ::')
    setIsShowLoading(true)

    const requestOptions = {
      method: 'POST',
    };

    const result =  await fetch(api.requestDocuments.getRequestDocumentsSubmit(referenceNo,`?token=${tokenSms}`), requestOptions)
    .then(response => response.json())
    .then(data => {
      return data
    }, (error) => {
      if (error) {
        setIsShowAlertErrorTold(true)
        setTimeout(function(){
          setIsShowAlertErrorTold(false)
        }, 2000)
      }
    });

    setIsShowLoading(false)

    if(result?.status == 'RECEIVED'){
      setIsStep('submit')
      window.scrollTo(0, 0);
    }else{
      setIsShowAlertErrorTold(true)
      setTimeout(function(){
        setIsShowAlertErrorTold(false)
      }, 2000)
      return
    }

  }

  return (
  <div className="w-full flex bg-white font-thonburi">

    <div className={'w-full bg-black  bg-opacity-30 h-screen z-40 justify-center flex align-middle '+((isShowUploadModal)? ' fixed ' : ' hidden ')}>

      <div className=' flex-wrap w-full lg:w-[100%] h-full lg:h-[100%]  bg-opacity-100 bg-white rounded-none md:rounded-lg z-50 mt-0 '>
        <div className=' relative w-full'>

          <div className="flex flex-wrap w-full bg-green-500 h-[56px] px-4 justify-center">
            <div className="flex w-[1092px] ">
              <div className="flex-none">
                <div className='mt-[4px]'>
                  <ThaivivatLogo></ThaivivatLogo>
                </div>
              </div>
            </div>
          </div>
          
          <div class="flex lg:flex-none h-screen lg:h-fit  flex-col lg:flex-row w-full flex-nowrap lg:flex-wrap">

          
            <div className='flex lg:flex-none w-full h-[56px] py-5 px-6 border-b border-grey-500'>
              <div className='grow w-full inline-flex'>
                <img onClick={()=> { showConfirmBack() }} src={iconArrorLeft} className='w-[24px] h-[24px] mr-[16px]' alt="" />
                <span data-testid='popup-title-label' className='font-thonburi text-[16px] h-[26px] overflow-hidden text-ellipsis whitespace-nowrap leading-6 font-medium'>{headerDocType}</span>
              </div>
            </div>

            <div className='w-full overflow-y-scroll' >
              <div className='flex flex-wrap w-full '>
                <div className='flex flex-wrap w-full px-6 mt-[16px]'>
                    <Dropzone 
                          maxSize={(10*1024*1024)}
                          accept={'image/jpeg, image/png, image/heic, image/heif'}
                          onDropRejected={(e) => {
                            const rej = []
                            for (let i = 0; i < e.length; i++) {
                              if (
                                e[i].file.path.toString().toLowerCase().indexOf('.heic') >= 0 ||
                                e[i].file.path.toString().toLowerCase().indexOf('.heif') >= 0
                              ) {
                                rej.push(e[i].file)
                              }
                            }
                              onUploadFile(rej, docType) 
                            
                          }}
                          onDropAccepted={acceptedFiles => { 
                            onUploadFile(acceptedFiles, docType) 
                          }}>
                        {({getRootProps, getInputProps}) => (
                          <section data-testid='popup-upload-button' {...getRootProps({className: 'dropzone'})} className={' flex w-full  mt-2 border rounded-lg justify-center  border-dashed items-center border-grey-300 h-[136px]' }>
                            <div >
                              <input className='dropzone' {...getInputProps()} />
                              <div className='justify-center  flex mt-[42px]'>
                                <div className='icon-center bg-[#E6F6EA]  w-[48px] h-[48px]'>
                                  <img src={iconModalUpload} className='correct-circle-check w-[24px] h-[24px]' alt="" />
                                </div>
                              </div>
                              <div className=' flex flex-wrap mt-3 justify-center text-center'>
                                <label className='text-sm text-green-500'>คลิกเพื่ออัพโหลด </label>
                                <label className='ml-1 text-sm text-grey-800'>รูปภาพของคุณ</label>
                              </div>
                              <div className='w-full flex flex-wrap justify-center text-center mt-[4px]  mb-[42px]'>
                              
                                <div className='w-full flex'>
                                  <label className='w-full text-xs font-normal text-grey-600'>PNG, JPG (สูงสุดไม่เกิน 25mb.)</label>
                                </div>
                              
                              </div>
                              
                            </div>
                          </section>
                        )}
                  </Dropzone>
              </div>
            </div>

              <div className=' flex-1 lg:flex-none w-full px-6 mt-4  flex-wrap '>
                <div className='w-full flex' >
                  {
                    fileList.length > 0 ? 
                      <div className='w-full flex mb-[16px]' >
                        <div className='flex flex-wrap w-1/2'>
                          <span className='font-thonburi font-[600]'>{fileList.length} รายการ</span>
                        </div>
                        <div className='flex flex-wrap w-1/2 pl-2 justify-end  '>
                          <span onClick={ () => { showConfirmDelete(clearAll,docType) }} className='font-thonburi text-[#009640] text-[16px] '> ลบทั้งหมด</span>
                        </div>
                      </div>
                    :null
                  }
                </div>

                <div className='w-full flex flex-row flex-wrap mb-[150px] ' >
                {
                  fileList.map(function(item, index){
                    console.log('fileList .map : ',fileList)
                    return ( 
                      item.uploadStatus === 'success' ? 
                      <div className="relative my-[5px] md:max-w-[104px]  max-w-[29%] md:max-h-[104px]  max-h-[29%] mx-[6px]">
                        <div className='flex w-full justify-center w-[100%] h-[100%]'>
                          <img className={'w-full rounded-lg border '+(item.uploadStatus === 'success' ? 'border-[#E5E5E5]':'border-[#FFA100]')+' '} src={item.filePath}/>
                        </div>
                        <div class="absolute top-[8px] right-[8px] w-[20px] h-[20px] rounded-full justify-center flex ">
                          <div className='bg-black bg-opacity-60 icon-center  w-[20px] h-[20px] '>
                            <img  onClick={(e)=>{ showConfirmDelete(deleteImage,docType,index) }} className='w-[20px] h-[20px] max-w-none' src={iconTrash}/>
                          </div>
                        </div>
                      </div>
                      :
                      <div className="relative my-[5px] md:max-w-[104px]  max-w-[29%] md:max-h-[104px]  max-h-[29%] mx-[6px]">
                        <div className='flex w-full justify-center w-[100%] h-[100%]'>
                          <img className={'w-full rounded-lg border '+(item.uploadStatus === 'success' ? 'border-[#E5E5E5]':'border-[#FFA100]')+' '} src={item.fileImage}/>
                        </div>
                        <div class="absolute top-[8px] right-[8px] w-[20px] h-[20px] rounded-full justify-center flex ">
                          <div className='bg-[#FFA100] icon-center  w-[20px] h-[20px] '> 
                            {/* onReUploadFile */}
                            <img onClick={(e) => { onReUploadFile(item.fileUpload, docType, index) }} className='w-[20px] h-[20px] max-w-none' src={iconReset}/>
                          </div>
                        </div>
                      </div>
                        
                    )
                  })
                }
                </div>
                
              </div>
            </div>

            <div className='flex-wrap flex w-full mt-6 md:mt-20  md:h-80px md:justify-center  bg-white border-t-[0.5px] border-grey-500 fixed bottom-0 right-0'>
              <div className='flex flex-wrap w-full md:w-[1092px] md:justify-end '>
                <button 
                    data-testid='next-button'
                    onClick={()=> { saveFiles() }}
                    className={'w-full m-[16px]   md:w-[160px] lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  bg-green-500 text-white'}>
                      บันทึก
                </button>
              </div>
            </div>

            <div className={((isShowAlertSuccess)? ' absolute ' : ' hidden ' )+ ' flex top-5 inset-x-0 mx-auto shadow-alert w-[188px] h-[40px] py-[10px] px-[12px] mb-[96px] bg-black rounded-lg '}>
              <div className='flex w-full'>
                <div className='w-1/6'>
                  <img src={iconVector} alt="icon-warning-alert" className='w-[20px] h-[20px] mr-[8px] my-auto' />
                </div>
                <div className='w-4/6 flex justify-center'>
                    <span onClick={(e) => {  }} className=' cursor-pointer text-sm not-italic font-medium text-white font-[400] text-[16px] my-auto' >ลบสำเร็จ</span>
                </div>
                <div className='w-1/6 flex justify-end'>
                    <button onClick={(e) => { setIsShowAlertSuccessTold(false) }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
                </div>
              </div>
            </div>

            {/* <div className={((isShowAlertErrorTold)? ' absolute ' : ' hidden ' )+ ' flex top-5 inset-x-0 mx-auto shadow-alert w-[188px] h-[40px] py-[10px] px-[12px] mb-[96px] bg-black rounded-lg '}>
              <div className='flex w-full'>
                <div className='w-1/6'>
                  <img src={iconError} alt="icon-warning-alert" className='w-[20px] h-[20px] mr-[8px] my-auto' />
                </div>
                <div className='w-4/6 flex justify-center'>
                    <span onClick={(e) => {  }} className=' cursor-pointer text-sm not-italic font-medium text-white font-[400] text-[16px] my-auto' >เกิดข้อผิดพลาด</span>
                </div>
                <div className='w-1/6 flex justify-end'>
                    <button onClick={(e) => { setIsShowAlertErrorTold(false) }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
                </div>
              </div>
            </div> */}

          </div>

        </div>
      
      </div>

    </div>

    <div className={' w-full bg-black  bg-opacity-30 h-screen z-40 justify-center flex align-middle '+((isShowHelpModal)? ' fixed ' : ' hidden ')}>
      <div className=' flex-wrap w-full lg:w-[480px] h-full lg:h-[676px]  bg-opacity-100 bg-white rounded-none md:rounded-lg z-50  lg:mt-[20px]  mt-[0px]'>
        <div className=' relative w-full'>
          <div class="flex lg:flex-none h-screen lg:h-fit  flex-col lg:flex-row w-full flex-nowrap lg:flex-wrap">

            <div className='hidden md:flex lg:flex-none w-full h-[20px] mt-[20px]'>
              <div className='flex-none ml-auto mr-[1.5rem]'>
                <img data-testid='popup-close-button' onClick={ (e)=> { setIsShowHelpModal(false) }} src={iconModalClose} alt="ic-close-modal" className=' cursor-pointer w-[16px] h-[16px]' /> 
              </div>
            </div>
            <div className='flex md:hidden lg:flex-none w-full h-[20px] mt-[20px]'>
              <div className='flex-none ml-auto mr-[1.5rem]'>
                <img data-testid='popup-close-button' onClick={ (e)=> { setIsShowHelpModal(false) }} src={iconModalClose} alt="ic-close-modal" className=' cursor-pointer w-[24px] h-[24px]' /> 
              </div>
            </div>
          
            <div className='flex md:hidden flex-wrap w-full justify-center border-b-[0.5px] border-grey-500 mt-[15px] mb-[20px] '>
            </div>

            <div className='flex lg:flex-none flex-wrap w-full h-[72px] px-6 '>
              <div className='flex flex-wrap w-full justify-center'>
                <span className='md:flex text-xl md:text-[24px] font-medium leading-8 md:leading-[44px] text-center'>หากคุณต้องการให้เราติดต่อกลับ</span>
              </div>
              <div className='flex flex-wrap w-full justify-center mt-[0px] mb-[16px]'>
                <span className='hidden md:flex text-base md:text-[18px] leading-6 text-grey-600 text-center'>กรอกรายละเอียดปัญหาที่คุณพบเจอเกี่ยวกับ<br/>การเรียกร้องค่าสินไหมทดแทน</span>
                <span className='flex md:hidden  text-base md:text-[18px] leading-6 text-grey-600 text-center'>กรอกรายละเอียดปัญหาที่คุณพบเจอ<br/>เกี่ยวกับการเรียกร้องค่าสินไหมทดแทน</span>
              </div>


              <div className=' flex-wrap w-full '>
                <div className='flex flex-wrap w-full'>
                  <div className=' flex-wrap w-full'>
                    <span className='text-sm font-medium leading-5 text-black'>ชื่อผู้ติดต่อ<span className='text-red-500'>*</span></span>
                  </div>
                  <div className=' flex-wrap w-full'>
                    <input data-testid='dropLead-name-input' value={''} onChange={ (e)=> {  }} type={'search'} className={'w-full h-[48px] mt-1  font-thonburi text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ชื่อ - นามสกุล' />
                  </div>  
                </div>
                <div className='flex flex-wrap w-full mt-6'>
                  <div className=' flex-wrap w-full'>
                    <span className='text-sm font-medium leading-5 text-black'>อีเมล </span><span className='text-grey-500 font-normal'>(ถ้ามี)</span>
                  </div>
                  <div className=' flex-wrap w-full'>
                    <input data-testid='dropLead-email-input' value={''} onChange={ (e)=> {  }} type={'search'} className={'w-full h-[48px] mt-1  font-thonburi text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='your@company.com' />
                  </div>  
                </div>
                <div className='flex flex-wrap w-full mt-6'>
                  <div className=' flex-wrap w-full'>
                    <span className='text-sm font-medium leading-5 text-black'>เบอร์โทรศัพท์<span className='text-red-500'>*</span></span>
                  </div>
                  <div className=' flex-wrap w-full'>
                    <input data-testid='dropLead-contactNo-input' value={''} onChange={ (e)=> { 
                      }} type={'search'} className={'w-full h-[48px] mt-1  font-thonburi text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  placeholder='000 000 0000' />
                  </div>  
                </div>
                <div className='flex flex-wrap w-full mt-6'>
                  <div className=' flex-wrap w-full'>
                    <label for="customer-message" className='text-sm font-medium leading-5 text-black'>ข้อความ<span className='text-red-500'>*</span></label>
                  </div>

                  <textarea data-testid='dropLead-message-input' id="customer-message" rows={5} value={''} onChange={ (e)=> {  }} type={'search'} className={'w-full h-[104px] mt-1  font-thonburi text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  />

                </div>

                <button 
                    data-testid='dropLead-submit-button'
                    onClick={'submit'}
                    className={'w-full lg:px-4 text-base leading-6 h-[48px]  mt-6 md:h-12 font-medium rounded-lg border-radius-other  bg-green-500 text-white '}>
                      ส่งข้อความ
                </button>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>
    
    <div className="flex flex-wrap w-full bg-white font-thonburi overflow-y-hidden  overflow-x-hidden ">

      <div className='fixed w-full z-30'>
        <div className='flex w-full flex-wrap'>
          <div className={"flex flex-wrap w-full "+(isStep == 'info' ? 'bg-green-500 ':' ')+" py-2.5 md:py-4 px-4 justify-center"}>


            <div className="flex w-[1092px] ">

              <div className="flex-none">
                <div className=''>
                  <div className='h-[34] md:h-[40px]' >
                    {
                      isStep == 'info' ?  
                      <ThaivivatLogo></ThaivivatLogo>
                      :
                      ''
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <div onClick={(e) => { setIsShowHelpModal(true) }} className={"fixed !block right-10 w-[136px] h-[48px]  bg-white border  rounded-full  px-[20px] py-[12px] shadow-md cursor-pointer  " } style={{bottom:isShowHelpButton}}  >
            <div className="flex" >   
              <img src={imgQuestion} alt="banner-claim-paper" className='w-[20px] h-[20px] mr-[8px]' />
              <span>ช่วยเหลือ</span>
            </div>
          </div>


        </div>
      </div>

  
      <div className='flex w-full overflow-y-auto mt-[56px] md:mt-[56px]'>
        
        { isStep == 'info' ? 
          <AdditionalDocumentInfo openUpload={openUpload} submitRequestDocuments={submitRequestDocuments}  ></AdditionalDocumentInfo>
          :''
        } 
        { isStep == 'error' ? 
          <AdditionalDocumentError errorCode={errorCode}></AdditionalDocumentError>
          :''
        }
        { isStep == 'submit' ? 
          <AdditionalDocumentSubmit></AdditionalDocumentSubmit>
          :''
        }
    
      </div>

    </div>

      {
        isShowLoading ?
          <ProgressWaiting />
        :
        null
      }

      {
          isShowAlertError ?

          <ModalAlertError 
            title={alertTitle}
            message={alertMessage}
            confirmClick={confirmClickError}
          />
          :
          null
      }

        <div className={((isShowAlertErrorTold)? ' absolute ' : ' hidden ' )+ ' flex top-10 z-50 inset-x-0 mx-auto shadow-alert w-[188px] h-[40px] py-[10px] px-[12px] mb-[96px] bg-black rounded-lg '}>
          <div className='flex w-full'>
            <div className='w-1/6'>
              <img src={iconError} alt="icon-warning-alert" className='w-[20px] h-[20px] mr-[8px] my-auto' />
            </div>
            <div className='w-4/6 flex justify-center'>
                <span onClick={(e) => {  }} className=' cursor-pointer text-sm not-italic font-medium text-white font-[400] text-[16px] my-auto' >เกิดข้อผิดพลาด</span>
            </div>
            <div className='w-1/6 flex justify-end'>
                <button onClick={(e) => { setIsShowAlertErrorTold(false) }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
            </div>
          </div>
        </div>

  </div>
  )
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => {
  return {
    updateNotify : (notify) =>  dispatch(updateNotify( notify )),
    updateLicense : (payload) =>  dispatch(updateLicense(payload)),
    updateContactInfo : (payload) =>  dispatch(updateContactInfo(payload)),
    updateContactInfoTemporary : (payload) =>  dispatch(updateContactInfoTemporary(payload)),
    updateClaimType : (payload) =>  dispatch(updateClaimType(payload)),
    deleteDocTypeAll : () =>   dispatch(deleteDocTypeAll()),
    updateClaimId : (payload) =>   dispatch(updateClaimId(payload)),
    updateRequestDocuments : (payload) =>   dispatch(updateRequestDocuments(payload)),

  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDocument);